import { onImageUpload } from "./onImageUpload";

export const encodeFileToBase64 = (fileBlob, setIdCard) => {
  onImageUpload(fileBlob, setIdCard);
};
